import Link from 'next/link';
import React, { SyntheticEvent } from 'react';

import { basePathResolve, indexOfRoute } from '@tb-core/helpers/utils';
import { Props } from '@tb-core/types';

export interface SafeLinkProps extends Props {
    children?: JSX.Element | JSX.Element[] | string;
    href: string;
    onClick?: (event: SyntheticEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const IsExternal = (href: string) => {
    return href && href.indexOf('http') >= 0;
};

const Anchor = (
    { children, href, target, ...props }: SafeLinkProps,
    ref: any
) => {
    const isExternalLink = IsExternal(href);

    return (
        <a
            {...props}
            href={href}
            ref={typeof ref === 'function' ? ref : () => {}}
            target={target || (isExternalLink ? '_blank' : '_self')}
            rel={isExternalLink ? 'noreferrer noopener' : ''}
        >
            {children}
        </a>
    );
};

// const SafeAnchor = React.forwardRef(Anchor);

const SafeLink = (props: SafeLinkProps) => (
    <>
        {indexOfRoute(props.href) < 0 ? (
            <Anchor {...props} />
        ) : (
            <Link
                as={props.as || props.href}
                href={basePathResolve(props.href)}
            >
                <a
                    {...props}
                    ref={typeof props.ref === 'function' ? props.ref : () => {}}
                >
                    {props.children}
                </a>
            </Link>
        )}
    </>
);

export default SafeLink;
